import { QuestionGroupDTO, QuestionDTO } from 'src/AngularJS/Models/Quality/questions.models';
import { AnswerDTO } from 'src/AngularJS/Models/Quality/answer.model';
import { Group } from 'src/AngularJS/Models/group.model';

export interface FormsApiModel {
    Forms: ApplicationDTO[],
    SurveyFolders: string[],
    CoachingFolders: string[],
    QaFolders: string[],
    SurveyCreatePermission: boolean,
    CoachingCreatePermission: boolean,
    QaCreatePermission: boolean,
    SurveyWritePermission: boolean,
    CoachingWritePermission: boolean,
    QaWritePermission: boolean,
    SurveyReadPermission: boolean,
    CoachingReadPermission: boolean,
    QaReadPermission: boolean,
}

export interface AddFormApiModel {
    Form: ApplicationDTO,
    Survey: Survey
}

export interface FormsExtendedDataApiModel {
    QuestionGroups: QuestionGroup[],
    Groups: Group[],
    Survey: Survey
}

export class ApplicationDTO {
    ApplicationID: number;
    CompanyID: number;
    ApplicationName: string;
    ApplicationDescription: string;
    RecordingType: RecordingType | null;
    Active: boolean;
    ApplicationType: ApplicationFormType;
    ReadAccess: boolean;
    showInGrid: boolean;
    isSelected: boolean;
    QuestionGroups: QuestionGroup[];
    showDescriptionInput: boolean;
    Folder: string;
    DateCreated: Date;
    DateLastEdited: Date;
    GroupsAssigned: Group[];
    Survey: Survey;
}

export const enum RecordingType {
    Audio = 0,
    Text = 1,
    CoachingSession = 2,
    Survey = 3,
    Quiz = 4
}

export const enum ApplicationFormType {
    QA = 0,
    Coaching = 1,
    Survey = 2,
    Imported = 3
}

export interface QuestionGroup extends QuestionGroupDTO {
    Questions: Question[],
    isUsed: boolean,
    showDescriptionInput: boolean
}

export interface Question extends QuestionDTO {
    Answers: Answer[],
    QuestionTypeTemp: number,
    questionCollapsed: boolean,
    showDescriptionInput: boolean
}

export interface Answer extends AnswerDTO {
    PercentCorrectDisplay
}

export class Survey {
    ApplicationID: number;
    CompanyID: number;
    StartDate: Date | null;
    EndDate: Date | null;
    IntervalType: number;
    IsOpen: boolean;
    TakeLimitPerTimeFrame: number;
}

export const enum FormDetailsDialogType {
    None = 0,
    New = 1,
    Edit = 2,
    Copy = 3
}

export const enum ConfirmationDialogType {
    None = 0,
    DeleteForm = 1,
    LeaveWithoutSaving = 2,
    DiscardChanges = 3,
    DeactivateSection = 4,
    DeleteSection = 5,
    ChangeQuestionType = 6,
    DeleteQuestion = 7,
    UnshowableDependents = 8,
    EmptyNameField = 9
}

export const enum ActionNoticeType {
    None = 0,
    Added = 1,
    Copied = 2,
    Reassigned = 3,
    Deleted = 4,
    MultiDeleted = 5,
}
